import { Link } from "react-router-dom";
import Logo from "./Logo";

const LINKS = [
  { name: "Books & Workbooks", href: "/books" },
  { name: "About Chaplain Derrick", href: "/about" },
  { name: "Speaking & Signings", href: "/speaking" },
  { name: "Group Copies", href: "/group-copies" },
  { name: "Ask Chaplain Derrick", href: "/ask" },
  { name: "Facilitators", href: "/facilitators" },
  { name: "Licensing & Permissions", href: "/licensing" },
  { name: "Invite / Booking", href: "/booking" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-navy-deep text-ivory/70">
      <div className="mx-auto max-w-6xl px-5 sm:px-8 py-16 sm:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-6">
            <Logo dark />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-ivory/60">
              The home of the book From Diagnosis to Goodbye and its companion
              resources — written to see the person, hear the voice, and honor
              the journey.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.22em] text-gold">
              Explore
            </p>
            <ul className="mt-5 space-y-3">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <Link
                    to={l.href}
                    data-testid={`footer-link-${l.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="text-sm hover:text-ivory transition-colors"
                  >
                    {l.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.22em] text-gold">
              A gentle note
            </p>
            <p className="mt-5 text-sm leading-relaxed text-ivory/60">
              This site shares a book, resources, and speaking — not medical
              advice. If you or someone you love is in immediate crisis, please
              call your local emergency number.
            </p>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-ivory/10 flex flex-col sm:flex-row gap-3 justify-between text-xs text-ivory/40">
          <p>© {year} Chaplain Derrick Hall. All rights reserved.</p>
          <p>From Diagnosis to Goodbye™ — trademark application pending.</p>
        </div>
      </div>
    </footer>
  );
}
